<template>
  <div class="tutor-card card mb-3 shadow-sm">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-start mb-3">
        <div>
          <h5 class="card-title mb-1">
            {{ recommendation.tutorName }}
            <span v-if="recommendation.scoreBreakdown.lastMinuteBoost" class="badge bg-warning ms-2" title="Priorità per richiesta urgente">
              ⚡ Disponibile subito
            </span>
          </h5>
          <div class="subjects-tags">
            <span v-for="subject in recommendation.matchedSubjects" :key="subject" class="badge bg-secondary me-1">
              {{ subject }}
            </span>
          </div>
        </div>
        <div class="match-score-container text-center">
          <div class="match-score-circle" :style="getScoreColor(recommendation.finalScore)">
            {{ Math.round(recommendation.finalScore * 100) }}%
          </div>
          <small class="text-muted">Match</small>
        </div>
      </div>

      <!-- Available time slots -->
      <div v-if="timeSlots.length > 0" class="time-slots-section">
        <h6 class="mb-2">
          <i class="fas fa-clock me-1"></i>
          Prossime disponibilità:
        </h6>
        <div class="time-slots">
          <button
            v-for="(slot, index) in displayedSlots"
            :key="index"
            class="btn btn-outline-primary btn-sm me-2 mb-2"
            @click="$emit('book-slot', { tutor: recommendation, slot })"
          >
            {{ formatSlot(slot) }}
          </button>
        </div>
        <div v-if="isLoadingSlots" class="text-center my-2">
          <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Caricamento...</span>
          </div>
        </div>
      </div>
      <div v-else-if="isLoadingSlots" class="text-center my-2">
        <div class="spinner-border spinner-border-sm" role="status">
          <span class="visually-hidden">Caricamento disponibilità...</span>
        </div>
      </div>
      <div v-else class="text-muted">
        <i class="fas fa-info-circle me-1"></i>
        Nessuna disponibilità immediata
      </div>

      <!-- Action buttons -->
      <div class="mt-3 d-flex gap-2">
        <button
          class="btn btn-primary btn-sm"
          @click="$emit('view-details', recommendation)"
        >
          Vedi tutte le disponibilità
        </button>
        <button
          class="btn btn-outline-secondary btn-sm"
          @click="$emit('view-profile', recommendation.tutorId)"
        >
          Profilo
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'TutorRecommendationCard',
  props: {
    recommendation: {
      type: Object,
      required: true
    },
    timeSlots: {
      type: Array,
      default: () => []
    },
    isLoadingSlots: {
      type: Boolean,
      default: false
    },
    maxSlotsToShow: {
      type: Number,
      default: 5
    }
  },
  computed: {
    displayedSlots() {
      return this.timeSlots.slice(0, this.maxSlotsToShow);
    }
  },
  methods: {
    getScoreColor(score) {
      // Color gradient from red to yellow to green based on score
      let color;
      if (score >= 0.8) {
        color = '#28a745'; // Green
      } else if (score >= 0.6) {
        color = '#20c997'; // Teal
      } else if (score >= 0.4) {
        color = '#ffc107'; // Yellow
      } else {
        color = '#fd7e14'; // Orange
      }
      return {
        borderColor: color,
        color: color
      };
    },
    formatSlot(slot) {
      // Format: "Mar 18, 14:00-15:00"
      const date = moment(slot.data);
      const day = date.format('ddd DD');
      return `${day}, ${slot.oraInizio}-${slot.oraFine}`;
    }
  }
};
</script>

<style scoped>
.tutor-card {
  transition: transform 0.2s, box-shadow 0.2s;
  border-left: 4px solid #007bff;
}

.tutor-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.match-score-container {
  min-width: 70px;
}

.match-score-circle {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 3px solid;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 1.1rem;
  margin: 0 auto 0.25rem;
}

.subjects-tags {
  margin-top: 0.5rem;
}

.time-slots-section {
  background-color: #f8f9fa;
  padding: 1rem;
  border-radius: 0.5rem;
  margin-bottom: 0.5rem;
}

.time-slots {
  display: flex;
  flex-wrap: wrap;
}

.time-slots .btn {
  white-space: nowrap;
}

.badge {
  font-size: 0.75rem;
}
</style>
